module.exports = __webpack_public_path__ + "static/404-bg-68c53b2ce34e46ff8eea064ed15b5599.png";